import { FC } from 'react';

import { Box, Grid, Link, Typography } from '@mui/material';

import { DateTime } from 'luxon';

import { CompanySellerRoomItem } from '@type-def_iqfu/chat/CompanySellerRoomItem';

import { DateOutputFormatWithColon } from '@constants_iqfu';

type Props = {
  chatRooms: CompanySellerRoomItem[];
};

const SellingConsultationInfo: FC<Props> = ({ chatRooms }) => {
  const getTimeDifferenceFromNow = (isoDateString: string): string => {
    const now = new Date();
    const target = new Date(isoDateString);
    const diffMs = now.getTime() - target.getTime();
    const hoursAgo = Math.floor(diffMs / (1000 * 60 * 60));
    const daysAgo = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    return daysAgo >= 1 ? `（${daysAgo}日前）` : `（${hoursAgo}時間前）`;
  };

  return (
    <Box>
      <Grid item>
        <Typography
          sx={{
            fontSize: '2.2rem',
            fontWeight: 700,
            textAlign: 'center',
            color: '#FFFFFF',
            background: '#29C29C',
            py: '1rem',
          }}
        >
          売却相談
        </Typography>
        {chatRooms.length > 0 ? (
          <Box sx={{ maxHeight: '10rem', overflowY: 'auto' }}>
            {chatRooms.map((room) => (
              <Grid container item key={room.id} sx={{ my: 1, justifyContent: 'space-between', alignItems: 'center' }}>
                <Grid item xs={2}>
                  <Typography sx={{ fontSize: '1.4rem' }}>
                    {DateTime.fromISO(room.last_chat_item_sent_at).toFormat(DateOutputFormatWithColon)}
                    <span style={{ fontSize: '1.2rem', marginLeft: '0.5rem', color: 'red' }}>
                      {getTimeDifferenceFromNow(room.last_chat_item_sent_at)}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography key={room.id} sx={{ fontWeight: 700, fontSize: '1.6rem' }}>
                    {room.seller_name}様から新規売却相談が届いています。
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Link href={`/console/company/chat/talk?roomId=${room.id}`}>
                    <Box sx={{ textAlign: 'right', mr: 1 }}>
                      <Typography
                        sx={{ fontSize: '1.4rem', textDecoration: 'underline', color: '#3D5DA2', cursor: 'pointer' }}
                      >
                        チャットを確認する
                      </Typography>
                    </Box>
                  </Link>
                </Grid>
              </Grid>
            ))}
          </Box>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 2 }}>
            <Typography sx={{ fontWeight: 700, fontSize: '1.6rem' }}>未対応の売却相談がありません</Typography>
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default SellingConsultationInfo;
